// Avoid duplicate binding while legacy Custom Liquid is being removed.
(()=>{
if(document.querySelector('[id$="__custom_liquid_atAytF"]'))return;
(() => {
 const init=()=>{
  const root=document.querySelector('.shopify-policy__container');
  const content=root?.querySelector('.shopify-policy__body .rte');
  if(!content||content.dataset.tfPolicyDesigned)return;

  // Preserve all native policy text while accepting nested Shopify policy markup.
  if(location.pathname.includes('privacy-policy')){
   const source=content.querySelector('h2,h3')?.parentElement;
   if(!source)return;
      const fragment=document.createDocumentFragment();
   const group=document.createElement('section');group.className='tf-policy-group';
   let target=group;
   [...source.childNodes].forEach(node=>{
    if(node.nodeType===1&&node.matches('h2,h3')){
     const details=document.createElement('details');details.className='tf-policy-details';details.open=true;
     const summary=document.createElement('summary'),badge=document.createElement('span'),title=document.createElement('span');
     badge.className='tf-policy-row-icon';badge.setAttribute('aria-hidden','true');
     const icon=document.getElementById('TfPolicyIcon-policy-pages');if(icon)badge.append(icon.content.cloneNode(true));
     title.textContent=node.textContent;summary.append(badge,title);
     const body=document.createElement('div');body.className='tf-policy-detail-content';
     details.append(summary,body);group.append(details);target=body;
    }else target.append(node);
   });
   fragment.append(group);content.replaceChildren(fragment);content.dataset.tfPolicyDesigned='true';
   return;
  }
  const isTerms=location.pathname.includes('terms-of-service');
  const isArabic=document.documentElement.lang.toLowerCase().startsWith('ar');
  const boundaries=[...content.children].filter(e=>e.matches('h1,h2,h3')||(isTerms&&e.matches('p')&&/^\d+[.)]\s/.test(e.textContent.trim())&&e.querySelector('b,strong')));
  const headings=boundaries.filter(e=>!e.matches('h1')&&(!isTerms||(/[\u0600-\u06ff]/.test(e.textContent)===isArabic)));
  if(!headings.length)return;
  const sourceText=content.textContent.replace(/\s+/g,' ').trim();
  const entries=headings.map(heading=>{
   const title=heading.textContent.trim(),nodes=[];
   let next=heading.nextSibling;
   while(next&&!boundaries.includes(next)){nodes.push(next);next=next.nextSibling;}
   return{heading,title,nodes};
  });
  const path=location.pathname;
  let config;
  if(path.includes('privacy-policy'))config={plain:'Privacy ',accent:'Policy',intro:'How we collect, use, and protect your personal information at Tallah Beauty.',groups:[['Information handling',[0,1,2]],['Tracking & security',[3,5,6]],['Your rights & support',[4,7,8]]]};
  else if(path.includes('refund-policy')){
   if(entries[2]&&entries[3]&&entries[4]){entries[2].nodes.push(entries[3].heading,...entries[3].nodes,entries[4].heading,...entries[4].nodes);}
   config={plain:'Return & ',accent:'Exchange Policy',intro:'Everything you need to know about returns, exchanges, and refunds with Tallah Beauty.',groups:[['Our return policy',[0,1]],['Request submission',[2]],['Refunds & processing',[5]]]};
  }else if(path.includes('terms-of-service'))config={plain:'Terms & ',accent:'Conditions',intro:'Your guide to shopping, ordering, and your rights with Tallah Beauty.',groups:[['Customer terms & information',[0,1,2]],['Products, pricing & orders',[3,4,5,6,10]],['Delivery, payment & cancellations',[7,8,9]],['Legal & support',[11,12,13]]]};
  if(!config)return;
  // Fail safely if a future policy edit changes the expected source structure.
  const used=config.groups.flatMap(group=>group[1]);
  const expected=path.includes('refund-policy')?6:path.includes('privacy-policy')?9:14;
  if(entries.length!==expected)return;
  const icon=document.getElementById('TfPolicyIcon-'+"policy-pages");
  const fragment=document.createDocumentFragment();
  config.groups.forEach(([label,indexes])=>{
   const group=document.createElement('section');group.className='tf-policy-group';
   const caption=document.createElement('h2');caption.className='tf-policy-group-title';caption.textContent=label;if(!isArabic)group.append(caption);
   indexes.forEach(index=>{
    const entry=entries[index];if(!entry)return;
    const details=document.createElement('details');details.className='tf-policy-details';details.open=true;
    const summary=document.createElement('summary'),badge=document.createElement('span'),title=document.createElement('span'),body=document.createElement('div');
    badge.className='tf-policy-row-icon';badge.setAttribute('aria-hidden','true');if(icon)badge.append(icon.content.cloneNode(true));
    title.textContent=entry.title;summary.append(badge,title);body.className='tf-policy-detail-content';body.append(...entry.nodes);details.append(summary,body);group.append(details);
   });fragment.append(group);
  });
  content.replaceChildren(fragment);content.dataset.tfPolicyDesigned='true';
  const title=root.querySelector('.shopify-policy__title h1');
  if(title&&!isArabic){const accent=document.createElement('em');accent.textContent=config.accent;title.replaceChildren(document.createTextNode(config.plain),accent);}
  const intro=document.createElement('p');intro.className='tf-policy-intro';intro.textContent=config.intro;if(!isArabic)root.querySelector('.shopify-policy__title')?.append(intro);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();


(() => {
 const init=()=>{
  const labels={'/policies/privacy-policy':'Privacy Policy','/policies/refund-policy':'Return and Exchange Policy','/policies/terms-of-service':'Terms and Conditions'};
  document.querySelectorAll('.tf-footer a').forEach(a=>{const path=new URL(a.href,location.origin).pathname;if(labels[path])a.textContent=labels[path];});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

})();
